import { coordinates2points } from 'utils/coordinates';
import corners from 'utils/corners';
import last from 'lodash/last';
import getDistance from './getDistance';

function parseRoute(route) {
  const points = route.points || coordinates2points(route.coordinates);
  const bounds = corners(points);
  return {
    ...route,
    distance: route.distance || getDistance(points) / 1000,
    coordinates: undefined,
    points,
    bounds,
    start: points[0],
    finish: last(points),
  };
}

export default parseRoute;
